module.exports = __webpack_public_path__ + "static/media/Logo.ef3ae79b.svg";